<template>
  <index></index>
</template>


<script>
  import Index from './IndexMain'
  
  export default {
    name: 'topup',
    components: {
      Index
    }
  }
</script>



// WEBPACK FOOTER //
// Index.vue?2edd89f4